import React, { useState } from 'react';
import { FiPlay, FiX } from 'react-icons/fi';
import SeoHead from '../components/SeoHead';
import { useContent } from '../context/ContentContext';
import './VideosPage.css';

const youtubeId = (raw = '') => {
  if (!raw) return '';
  if (raw.length < 20 && !raw.includes('http')) return raw;
  const m = raw.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/);
  return m ? m[1] : raw;
};

const VideosPage = () => {
  const { videos, ready } = useContent();
  const [active, setActive] = useState(null);

  return (
    <>
      <SeoHead title="Videos" description="Watch our team audit websites, build IoT demos, and explain SEO &amp; digital marketing — practical walkthroughs from THINKINGWORLD." path="/resources/videos" />

      <header className="page-header">
        <div className="container">
          <span className="section-eyebrow">Videos</span>
          <h1>Audit + design walkthroughs.</h1>
          <p>Real screen recordings from real client work — sanitised but otherwise unfiltered.</p>
        </div>
      </header>

      <section className="section">
        <div className="container">
          {!ready && <p className="videos-empty">Loading…</p>}
          {ready && videos.length === 0 && <p className="videos-empty">No videos yet.</p>}

          <div className="videos-grid">
            {videos.map((v) => {
              const id = youtubeId(v.youtubeId);
              const thumb = `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
              return (
                <button
                  key={v.id}
                  type="button"
                  className="video-card"
                  onClick={() => setActive({ ...v, _id: id })}
                >
                  <div className="video-thumb">
                    <img src={thumb} alt={v.title} />
                    <span className="video-play"><FiPlay /></span>
                    {v.duration && <span className="video-duration">{v.duration}</span>}
                  </div>
                  <div className="video-body">
                    {v.category && <span className="video-cat">{v.category}</span>}
                    <h3>{v.title}</h3>
                    <p>{v.description}</p>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {active && (
        <div className="video-modal" onClick={() => setActive(null)}>
          <div className="video-modal-card" onClick={(e) => e.stopPropagation()}>
            <button className="video-modal-close" onClick={() => setActive(null)} aria-label="Close video">
              <FiX />
            </button>
            <div className="video-iframe">
              <iframe
                src={`https://www.youtube.com/embed/${active._id}?autoplay=1`}
                title={active.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className="video-modal-body">
              <h3>{active.title}</h3>
              <p>{active.description}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VideosPage;
